import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 48,
    fontSize: 6,
    flexDirection: "column",
    position: "relative",
    color: "#252525",
    flex: 1,
  },

  logoContainer: {
    marginBottom: 6,
  },

  logo: {
    width: 120,
  },

  titleContainer: {
    alignItems: "center",
    marginBottom: 15,
  },

  titleText: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    color: "#328AC4",
  },

  orderText: {
    fontSize: 8,
    color: "#666666",
    marginTop: 3,
  },

  sectionTitle: {
    marginTop: 5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottom: "0.7pt solid #328AC4",
  },

  subTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#328AC4",
  },

  table: {
    marginBottom: 9,
    border: "0.7pt solid #D5DCE3",
    borderRadius: 3,
    overflow: "hidden",
  },

  tableHeader: {
    backgroundColor: "#EEF3F7",
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.5pt solid #D5DCE3",
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.3pt solid #E8E8E8",
  },

  colIndex: {
    width: "5%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colItem: {
    width: "70%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colCategory: {
    width: "25%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colRut: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colNombre: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colFecha: {
    width: "16%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTelefono: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colDireccion: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colEmail: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colNacimiento: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colFamilia: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colTipo: {
    width: "22%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colMarca: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colModelo: {
    width: "16%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colSerie: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colServicio: {
    width: "14%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colHora: {
    width: "4%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colMeasurementItem: {
    width: "40%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colMeasurementValue: {
    width: "30%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  colMeasurementUnit: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  detailSection: {
    marginBottom: 9,
    padding: 7,
    backgroundColor: "#F7FAFC",
    borderLeft: "3pt solid #328AC4",
    borderRadius: 2,
  },

  detailTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 3,
  },

  bulletRow: {
    flexDirection: "row",
    marginTop: 3,
    paddingRight: 5,
  },

  bullet: {
    width: 12,
    fontSize: 9,
    color: "#328AC4",
  },

  bulletText: {
    flex: 1,
    fontSize: 8,
    lineHeight: 1.4,
  },

  emptyText: {
    fontSize: 7,
    color: "#777777",
    fontStyle: "italic",
    padding: 6,
  },

  observationSection: {
    marginTop: 4,
    padding: 6,
    border: "0.8pt solid #D5DCE3",
    borderRadius: 3,
    backgroundColor: "#FAFAFA",
  },

  observationTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 5,
  },

  observationText: {
    fontSize: 8,
    lineHeight: 1.5,
    textAlign: "justify",
  },

  signatureSection: {
    marginTop: 12,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  signatureBox: {
    width: 190,
    alignItems: "center",
  },

  signatureLine: {
    width: 160,
    borderTop: "0.8pt solid #555555",
    marginBottom: 5,
  },

  signatureName: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },

  signatureRole: {
    fontSize: 7,
    marginTop: 2,
    textAlign: "center",
  },

  signatureArea: {
    fontSize: 7,
    color: "#666666",
    marginTop: 1,
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    bottom: 14,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6.5,
    color: "#777777",
    borderTop: "0.5pt solid #DDDDDD",
    paddingTop: 4,
  },

  footerContact: {
    width: "80%",
  },

  footerPage: {
    width: "20%",
    textAlign: "right",
  },
});

const ReporteGarantiaPDF = ({
  cabecera = [],
  falla = [],
  servicio = [],
  repuestos = [],
  instrumento = [],
  check = [],
  medicion = [],
  seguridad = [],
  usuario = [],
  empresa = "",
  garantiaCab = {},
}) => {
  const tecnico = usuario?.[0];

  const nombreTecnico = tecnico
    ? `${tecnico.nombre || ""} ${tecnico.apellido || ""}`.trim()
    : "Técnico no informado";

  const numeroOrden = cabecera?.[0]?.folio || "";

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Logo */}
        {empresa && (
          <View style={styles.logoContainer}>
            <Image
              src={`../../${empresa}.png`}
              style={styles.logo}
            />
          </View>
        )}

        {/* Título */}
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>
            Reporte Técnico de Garantía
          </Text>

          {numeroOrden && (
            <Text style={styles.orderText}>
              Orden de servicio N° {numeroOrden}
            </Text>
          )}
        </View>

        {/* Información del cliente */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del cliente
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colRut}>RUT</Text>
            <Text style={styles.colNombre}>Nombre</Text>
            <Text style={styles.colFecha}>Fecha</Text>
            <Text style={styles.colTelefono}>Teléfono</Text>
            <Text style={styles.colDireccion}>Dirección</Text>
            <Text style={styles.colEmail}>Email</Text>
            <Text style={styles.colNacimiento}>F. Nac.</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((item, index) => (
              <View
                style={styles.tableRow}
                key={item.id || item.item_id || index}
              >
                <Text style={styles.colRut}>
                  {item.rut || ""}
                </Text>

                <Text style={styles.colNombre}>
                  {item.entidad || ""}
                </Text>

                <Text style={styles.colFecha}>
                  {formatearFecha(item.date)}
                </Text>

                <Text style={styles.colTelefono}>
                  {item.telefono || ""}
                </Text>

                <Text style={styles.colDireccion}>
                  {item.direccion || ""}
                </Text>

                <Text style={styles.colEmail}>
                  {item.correo || ""}
                </Text>

                <Text style={styles.colNacimiento}>
                  {item.fnaci
                    ? formatearFecha(item.fnaci, false)
                    : "------"}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del cliente.
            </Text>
          )}
        </View>

        {/* Información del equipo */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del equipo
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colFamilia}>Familia</Text>
            <Text style={styles.colTipo}>Tipo</Text>
            <Text style={styles.colMarca}>Marca</Text>
            <Text style={styles.colModelo}>Modelo</Text>
            <Text style={styles.colSerie}>Serie</Text>
            <Text style={styles.colServicio}>Servicio</Text>
            <Text style={styles.colHora}>Hora</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((item, index) => (
              <View
                style={styles.tableRow}
                key={`equipo-${item.id || index}`}
              >
                <Text style={styles.colFamilia}>
                  {item.familia || ""}
                </Text>

                <Text style={styles.colTipo}>
                  {item.tipo || ""}
                </Text>

                <Text style={styles.colMarca}>
                  {item.marca || ""}
                </Text>

                <Text style={styles.colModelo}>
                  {item.modelo || ""}
                </Text>

                <Text style={styles.colSerie}>
                  {item.serie || ""}
                </Text>

                <Text style={styles.colServicio}>
                  {item.servicio || ""}
                </Text>

                <Text style={styles.colHora}>
                  {item.horamaquina ?? ""}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del equipo.
            </Text>
          )}
        </View>

        {/* Diagnóstico */}
        {falla?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Diagnóstico técnico
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>
                <Text style={styles.colItem}>Descripción</Text>
                <Text style={styles.colCategory}>Categoría</Text>
              </View>

              {falla.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text style={styles.colItem}>
                    {item.item || "Sin descripción"}
                  </Text>

                  <Text style={styles.colCategory}>
                    {item.categoria || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Servicios */}
        {servicio?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Servicios realizados
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>
                <Text style={styles.colItem}>Descripción</Text>
                <Text style={styles.colCategory}>Categoría</Text>
              </View>

              {servicio.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text style={styles.colItem}>
                    {item.item || "Sin descripción"}
                  </Text>

                  <Text style={styles.colCategory}>
                    {item.categoria || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Detalle del servicio */}
        {check?.length > 0 && (
          <View style={styles.detailSection}>
            <Text style={styles.detailTitle}>
              Detalle del servicio
            </Text>

            {check.map((item, index) => (
              <View
                style={styles.bulletRow}
                key={item.item_id || item.id || index}
              >
                <Text style={styles.bullet}>•</Text>

                <Text style={styles.bulletText}>
                  {item.item || "Sin descripción"}
                </Text>
              </View>
            ))}
          </View>
        )}

        {/* Repuestos */}
        {repuestos?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Repuestos utilizados
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text
                  style={{
                    ...styles.colItem,
                    width: "95%",
                  }}
                >
                  Repuesto
                </Text>
              </View>

              {repuestos.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text
                    style={{
                      ...styles.colItem,
                      width: "95%",
                    }}
                  >
                    {item.item || "Sin descripción"}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Mediciones */}
        {medicion?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Mediciones efectuadas
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text style={styles.colMeasurementItem}>
                  Medición
                </Text>

                <Text style={styles.colMeasurementValue}>
                  Resultado
                </Text>

                <Text style={styles.colMeasurementUnit}>
                  Unidad
                </Text>
              </View>

              {medicion.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text style={styles.colMeasurementItem}>
                    {item.item || ""}
                  </Text>

                  <Text style={styles.colMeasurementValue}>
                    {item.valor ?? ""}
                  </Text>

                  <Text style={styles.colMeasurementUnit}>
                    {item.medida || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Seguridad */}
        {seguridad?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Verificaciones de seguridad
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text
                  style={{
                    ...styles.colItem,
                    width: "60%",
                  }}
                >
                  Verificación
                </Text>

                <Text
                  style={{
                    ...styles.colCategory,
                    width: "35%",
                  }}
                >
                  Resultado
                </Text>
              </View>

              {seguridad.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text
                    style={{
                      ...styles.colItem,
                      width: "60%",
                    }}
                  >
                    {item.item || ""}
                  </Text>

                  <Text
                    style={{
                      ...styles.colCategory,
                      width: "35%",
                    }}
                  >
                    {item.valor ?? ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Instrumentos */}
        {instrumento?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Instrumentos utilizados
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text style={styles.colItem}>
                  Instrumento
                </Text>

                <Text style={styles.colCategory}>
                  Categoría
                </Text>
              </View>

              {instrumento.map((item, index) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || index}
                >
                  <Text style={styles.colIndex}>
                    {index + 1}
                  </Text>

                  <Text style={styles.colItem}>
                    {item.item || ""}
                  </Text>

                  <Text style={styles.colCategory}>
                    {item.categoria || "INSTRUMENTOS"}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Observaciones */}
        <View style={styles.observationSection}>
          <Text style={styles.observationTitle}>
            Observaciones y recomendaciones
          </Text>

          <Text style={styles.observationText}>
            {garantiaCab?.observacionesFinales?.trim() ||
              "No se registraron observaciones adicionales."}
          </Text>
        </View>

        {/* Empuja la firma hacia el final */}
        <View style={{ flexGrow: 1 }} />

        {/* Firma */}
        <View
          style={styles.signatureSection}
          wrap={false}
        >
          <View
            style={styles.signatureBox}
            wrap={false}
          >
            <View style={styles.signatureLine} />

            <Text style={styles.signatureName}>
              {nombreTecnico.toUpperCase()}
            </Text>

            <Text style={styles.signatureRole}>
              Técnico responsable
            </Text>

            <Text style={styles.signatureArea}>
              Servicio Técnico
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerContact}>
            soporte@dormirbien.cl | General Parra #674 Oficina H,
            Providencia | +56 9 7632 1481 / +56 9 5423 4538
          </Text>

          <Text
            style={styles.footerPage}
            render={({ pageNumber, totalPages }) =>
              `Página ${pageNumber} de ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

const formatearFecha = (fecha, incluirHora = true) => {
  if (!fecha) return "------";

  try {
    let fechaConvertida;

    if (typeof fecha?.toDate === "function") {
      fechaConvertida = fecha.toDate();
    } else if (fecha instanceof Date) {
      fechaConvertida = fecha;
    } else {
      fechaConvertida = new Date(fecha);
    }

    if (Number.isNaN(fechaConvertida.getTime())) {
      return "------";
    }

    return moment(fechaConvertida).format(
      incluirHora
        ? "DD/MM/YYYY HH:mm"
        : "DD/MM/YYYY"
    );
  } catch (error) {
    console.error("Error al formatear fecha:", error);
    return "------";
  }
};

export default ReporteGarantiaPDF;